export var BackupStatus;
(function (BackupStatus) {
    BackupStatus["BackupPostureStatusUnspecified"] = "BACKUP_POSTURE_STATUS_UNSPECIFIED";
    BackupStatus["NotBackedUp"] = "NOT_BACKED_UP";
    BackupStatus["ViolationsDetected"] = "VIOLATIONS_DETECTED";
    BackupStatus["GenericBackups"] = "GENERIC_BACKUPS";
    BackupStatus["ExcludedFromBackup"] = "EXCLUDED_FROM_BACKUP";
    BackupStatus["AllViolationsMuted"] = "ALL_VIOLATIONS_MUTED";
    BackupStatus["Protected"] = "PROTECTED";
    BackupStatus["InitialClassification"] = "INITIAL_CLASSIFICATION";
    BackupStatus["Terminated"] = "TERMINATED";
    BackupStatus["Unsupported"] = "UNSUPPORTED";
    BackupStatus["Disconnected"] = "DISCONNECTED";
    BackupStatus["ActionRequired"] = "ACTION_REQUIRED";
    BackupStatus["Dlsg"] = "DLSG";
    BackupStatus["LimitExceeded"] = "LIMIT_EXCEEDED";
})(BackupStatus || (BackupStatus = {}));
